import { render, staticRenderFns } from "./TrustBox.vue?vue&type=template&id=6836a09e"
import script from "./TrustBox.vue?vue&type=script&lang=js"
export * from "./TrustBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports